import ApiClient from "./apiClient";
import { QueriesApi } from "./apiTypes";



const dashboardService = {
  getOperatingSystems:() => ApiClient.get(`openstack/summary/operating_systems`),
  getHypervisors:() => ApiClient.get(`openstack/summary/hypervisors`),
  getAppStatus:() => ApiClient.get(`app-status`),
  getServicesStatus:() => ApiClient.get(`services-statuses`),
  getFlavors:() => ApiClient.get(`openstack/flavors/summary`),
  getInstances:() => ApiClient.get(`openstack/instances/summary`),
  getClientsSum:() => ApiClient.get(`openstack/clients/summary`),
  getInvoicesSum:() => ApiClient.get(`billing/invoices/summary`),
  getAppStats:() => ApiClient.get(`app-status?page_size=20`),
  
  // getOperatingSystems:() => ApiClient.get(`openstack/summary/operating_systems`),
}

export default dashboardService